export default {"src":"/_next/static/media/trash-icon.3f89ff56.svg","height":17,"width":16};